export default "__VITE_ASSET__FTSh89OK__"